import axios from 'axios'
import {setupAxiosInterceptors} from "@/utils/request/axios-interceptors";

// 创建axios实例并设置拦截器
const instance = setupAxiosInterceptors();

export function POST(url, data) {
    const opts = {
        headers: {}
    }
    return instance.post(url, data, opts)
}

export function DELETE(url,data) {
    const opts = {
        headers: {}
    }
    return instance.delete(url,data,opts)
}

export function PUT(url, data) {
    const opts = {
        headers: {}
    }
    return instance.put(url, data, opts)
}

export function GET(url, data) {
    const opts = {
        headers: {}
    }
    return instance.get(url, data, opts)
}

export function PostForm(url, data) {
    const opts = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }
    return instance.post(url, data, opts)
}

export async function PostExcel(url, data) {
    try {
    const response = await axios.post(
        url,
        data,
        {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json'
        }
        }
    )

    const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })

    // 创建下载链接
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.setAttribute('download', '批量导出.xlsx')
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
    console.error('导出失败:', error)
    }
}

export async function DOWNLOAD(url, data) {
    try {
        const response = await axios.post(url, data, {
            responseType: 'blob'
        });

        // 1. 从响应头获取文件名（优先使用后端返回的文件名）
        let filename = data.file_name || 'download';
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1].replace(/['"]/g, '');
                // 处理UTF-8编码的文件名 (filename*=UTF-8''格式)
                const utf8FilenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/);
                if (utf8FilenameMatch && utf8FilenameMatch[1]) {
                    filename = decodeURIComponent(utf8FilenameMatch[1]);
                }
            }
        }

        // 2. 获取正确的Content-Type
        const contentType = response.headers['content-type'] || 'application/octet-stream';

        // 3. 创建Blob时使用后端返回的Content-Type
        const blob = new Blob([response.data], { type: contentType });

        // 4. 创建下载链接
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;

        // 优先使用后端返回的文件名
        link.setAttribute('download', filename);

        // 兼容性处理
        if (typeof link.download === 'undefined') {
            link.setAttribute('target', '_blank');
        }

        document.body.appendChild(link);
        link.click();

        // 清理
        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        }, 100);
    } catch (error) {
        console.error('文件下载失败:', error);
        // 可以在这里添加错误提示逻辑
        throw error;
    }
}




/**
 * 通用文件下载方法
 * @param {string} url 请求地址
 * @param {Object} params GET请求参数
 * @param {Object} data POST请求数据
 * @param {string} method 请求方法 GET/POST
 * @param {Function} onProgress 进度回调
 * @param {string} defaultFilename 默认文件名
 */
export async function DownloadFile({url, params = {}, data = {},
                                       method = 'GET', onProgress,
                                       defaultFilename = 'download.xlsx'}) {
    try {
        const response = await axios({url, method,
            params: method.toUpperCase() === 'GET' ? params : undefined,
            data: method.toUpperCase() === 'POST' ? data : undefined,
            responseType: 'blob',
            onDownloadProgress: onProgress,
            headers: {
                'Content-Type': 'application/json'
            }
        })
        // 处理文件名
        let filename = defaultFilename
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
            // 处理UTF-8编码的文件名
            const utf8FilenameRegex = /filename\*=UTF-8''([^;]+)/
            const matches = utf8FilenameRegex.exec(contentDisposition)
            if (matches && matches[1]) {
                filename = decodeURIComponent(matches[1])
            } else { // 回退处理普通文件名
                const filenameRegex = /filename="([^"]+)"/
                const normalMatches = filenameRegex.exec(contentDisposition)
                if (normalMatches && normalMatches[1]) {
                    filename = normalMatches[1]
                }
            }
        }
        // 2. 获取正确的Content-Type
        const contentType = response.headers['content-type'] || 'application/octet-stream';
        // 创建下载链接
        const blob = new Blob([response.data], { type: contentType })
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = filename
        // 兼容性处理
        if (typeof link.download === 'undefined') {
            link.setAttribute('target', '_blank');
        }
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(downloadUrl)
        return true
    } catch (error) {
        console.error('文件下载失败:', error)
        throw error
    }
}
